<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-btn color="primary" @click="newAudio" v-if="this.$store.state.routeSheet.status=='true'" dark>Nuevo Audio</v-btn>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Audio</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <p class="font-weight-bold">
                            OIDO DERECHO</p>
                        <v-layout>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od1"
                                    label="250"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od2"
                                    label="500"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od3"
                                    label="1000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od4"
                                    label="2000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od5"
                                    label="3000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od6"
                                    label="4000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od7"
                                    label="6000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.od8"
                                    label="8000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                        </v-layout>
                        <br>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <br>
                        <p class="font-weight-bold">
                            OIDO IZQUIERDO</p>
                        <v-layout>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi1"
                                    label="250"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi2"
                                    label="500"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi3"
                                    label="1000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi4"
                                    label="2000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi5"
                                    label="3000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi6"
                                    label="4000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi7"
                                    label="6000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                            <v-select
                                    :items="valoresAudio"
                                    v-model="audio.oi8"
                                    label="8000"
                                    :rules="[numberRule]"
                                    required
                            ></v-select>
                        </v-layout>
                        <!--v-layout>
                            <v-switch                                    
                                    v-model="audio.basal"
                                    :label="`Basal: ${audio.basal?'SI':'NO'}`"
                            ></v-switch>
                        </v-layout-->
                        <br>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <br>
                        <v-layout>
                            <diagnosticos :listaDiagnosticosPadre="this.audio.diagnosticos"
                                          @clicked="onClickChild">
                            </diagnosticos>
                            <v-layout>
                                <v-flex xs12 sm9 offset-sm1>
                                    <v-data-table ref="dtDiagnosticos"
                                                  :headers="[ { text: 'Nombre' }, { text: 'Clase' },{ text: 'Tipo' }]"
                                                  :items="this.audio.diagnosticos"
                                                  class="elevation-1"
                                                  hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left" width="120">
                                                <v-select
                                                        :items="clases"
                                                        v-model="props.item.clase"
                                                        label="Clase"
                                                        :rules="[v => !!v || 'Clase es requerida']"
                                                        required
                                                ></v-select>
                                            </td>
                                            <td class="text-xs-left" width="120">
                                                <v-select
                                                        :items="tipos"
                                                        v-model="props.item.tipo"
                                                        label="Tipo"
                                                        :rules="[v => !!v || 'Tipo es requerido']"
                                                        required
                                                ></v-select>
                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            No se han encontrado resultados para "{{ search }}".
                                        </v-alert>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-layout>
                        <div class="text-xs-center">
                            <v-btn color="primary" @click="savePatientAudio" dark>Guardar</v-btn>
                        </div>
                    </v-card-text>
                </v-card>

            </v-dialog>
        </v-form>
        <br>
        <br>
        <v-data-table
                :headers="headers"
                :items="audios"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                <td class="text-xs-left">
                    <table style="width:100%">
                        <tr>
                            <th>250</th>
                            <th>500</th>
                            <th>1000</th>
                            <th>2000</th>
                            <th>3000</th>
                            <th>4000</th>
                            <th>6000</th>
                            <th>8000</th>
                        </tr>
                        <tr>
                            <td>{{ props.item.value.od1 }}</td>
                            <td>{{ props.item.value.od2 }}</td>
                            <td>{{ props.item.value.od3 }}</td>
                            <td>{{ props.item.value.od4 }}</td>
                            <td>{{ props.item.value.od5 }}</td>
                            <td>{{ props.item.value.od6 }}</td>
                            <td>{{ props.item.value.od7 }}</td>
                            <td>{{ props.item.value.od8 }}</td>
                        </tr>
                    </table>
                </td>
                <td class="text-xs-left">
                    <table style="width:100%">
                        <tr>
                            <th>250</th>
                            <th>500</th>
                            <th>1000</th>
                            <th>2000</th>
                            <th>3000</th>
                            <th>4000</th>
                            <th>6000</th>
                            <th>8000</th>
                        </tr>
                        <tr>
                            <td>{{ props.item.value.oi1 }}</td>
                            <td>{{ props.item.value.oi2 }}</td>
                            <td>{{ props.item.value.oi3 }}</td>
                            <td>{{ props.item.value.oi4 }}</td>
                            <td>{{ props.item.value.oi5 }}</td>
                            <td>{{ props.item.value.oi6 }}</td>
                            <td>{{ props.item.value.oi7 }}</td>
                            <td>{{ props.item.value.oi8 }}</td>
                        </tr>
                    </table>
                </td>
                <td class="text-xs-left">
                    <ul id="diag">
                        <li v-for="item in props.item.value.diagnosticos">
                            {{ item.name }}-{{item.clase}}-{{item.clase}}
                        </li>
                    </ul>
                </td>
                <td>
                    <a @click="openGraphic(props.item)">DETALLE</a>

                </td>
                <td>
                    <v-tooltip top>
                        <v-btn v-if="$store.state.routeSheet.status=='true'" fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
        <v-card width="100%">
                <v-card-title>
                    <v-layout row wrap>
                        <v-flex
                        xs12
                        md5
                        >   <div align="center">
                                <span v-if="stsReportableDerecho">STS Reportable</span>
                            </div>
                            <Plotly id="oidoDerecho"
                                    :data="dataOidoDerecho" 
                                    :layout="layoutOidoDerecho" 
                                    :display-mode-bar="false">
                            </Plotly>
                        </v-flex>
                        
                        <img src="../../../assets/monigote.png" 
                                style="width:150px;height:150px;margin:auto"/>
                        
                        <v-flex
                        xs12
                        md5
                        >
                            <div align="center">
                                <span v-if="stsReportableIzquierdo">STS Reportable</span>
                            </div>
                            <Plotly id="oidoIzquierdo"
                                    :data="dataOidoIzquierdo" 
                                    :layout="layoutOidoIzquierdo" 
                                    :display-mode-bar="false">
                            </Plotly>
                        </v-flex>
                    </v-layout>
                </v-card-title>                
            </v-card>
        <v-dialog
                v-model="dialogGraphic"
                width="1000" persistent
        >
            <v-card>
                <v-card-title>
                    <img src="../../../assets/monigote.png" 
                                    style="width:150px;height:150px;margin:auto"/>
                    <v-layout row wrap>
                        <v-flex
                        xs12
                        md6
                        >                    
                            <Plotly id="detalle"
                                    :data="dataDetalle" 
                                    :layout="layoutDetalle" 
                                    :display-mode-bar="false">
                            </Plotly>
                        </v-flex>                                            
                    </v-layout>
                </v-card-title>
                <v-card-actions>

                    <v-btn
                            color="primary"
                            text
                            @click="dialogGraphic = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import Diagnosticos from "../diagnosticos/Diagnosticos"
    import PatientAudio from "../../../model/PatientAudio";
    import { Plotly } from 'vue-plotly';

    export default {
        props: ['company'],
        data() {
            return {
                radioGroup: 1,
                search: '',
                valid: false,
                valid2: false,
                dialogGraphic: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogDiagnostic: false,
                numberRule: v  => {
                    if (!isNaN(parseFloat(v)) && v >= 0 && v <= 200) return true;
                    return 'El número debe estar entre 0 y 150';
                },
                clases: ["PRE", "DEF"],
                tipos: ["PRI", "SUB", "REF"],
                valoresAudio: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150],
                diagnostico: {nombre: "", clase: "", tipo: ""},
                dialogSuccess: false,
                editedIndex: -1,
                show: false,
                audio: new PatientAudio(),
                prescripcion: {
                    medicamento: "",
                    tomar: "",
                    frecuencia: "",
                    tomar2: "",
                    frecuencia2: "",
                    dias: ""
                },
                headers: [
                    {text: 'Fecha y hora', value: 'fecha'},
                    {text: 'Oido Derecho', value: 'value.od1'},
                    {text: 'Oido Izquierdo', value: 'value.od2'},
                    {text: 'Diagnóstico', value: 'group'},
                    {text: 'Detalle', value: 'actions'},
                    {text: 'Acciones', value: 'actions'},
                ],
                frecuencias: ["CADA", "VECES"],
                frecuencias2: ["POR", "VECES"],
                audioEntity: {date: "", patientRouteSheet: "", value: ""},
                audios: [],
                list: [],
                years: [],
                dataOidoDerecho:[],
                layoutOidoDerecho:{
                    title: "Oido derecho",
                    xaxis: { title: "hz" },
                    yaxis: { title: "db" },
                    showlegend: true,
	                legend: {orientation:"h",
                        yanchor:"bottom",
                        y:1,
                        xanchor:"right",
                        x:1}
                },
                dataOidoIzquierdo:[],
                layoutOidoIzquierdo:{
                    title: "Oido Izquierdo",
                    xaxis: { title: "hz" },
                    yaxis: { title: "db" },
                    showlegend: true,
	                legend: {orientation:"h",
                        yanchor:"bottom",
                        y:1,
                        xanchor:"right",
                        x:1}
                },
                dataDetalle:[],
                layoutDetalle:{
                    title: "Detalle",
                    xaxis: { title: "hz" },
                    yaxis: { title: "db" },
                    showlegend: true,
	                legend: {orientation:"h",
                        yanchor:"bottom",
                        y:0.9,
                        xanchor:"right",
                        x:1}
                },
                stsReportableDerecho: false,
                stsReportableIzquierdo: false
            };
        },
        methods: {
            cleanData() {
                this.audio = new PatientAudio();
                this.dataOidoDerecho = [];
                this.dataOidoIzquierdo = [];
            },
            newAudio() {
                this.audio = new PatientAudio()
                this.audioEntity = {date: "", patientRouteSheet: "", value: ""},
                    this.editedIndex = -1
                this.dialog = true
                this.valid = false
                this.valid2 = false
            },
            getDateNow() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear()
                today.getHours()
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                var today = dd + '/' + mm + '/' + yyyy + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                return today
            },
            getYears() {
                let currentYear = new Date().getFullYear()
                for (let i = currentYear; i >= 1945; i--) {
                    this.years.push(i)
                }
            },

            savePatientAudio() {
                if (this.$refs.form.validate()) {
                    if (this.editedIndex == -1) {
                        this.audioEntity.date = new Date()
                        this.audioEntity.patientRouteSheet = this.$store.state.routeSheet
                        this.audioEntity.value = JSON.stringify(this.audio)
                        this.$store.dispatch('addPatientAudio', this.audioEntity).then(response => {
                            this.dialog = false
                            this.audio = new PatientAudio()
                            this.audioEntity = {date: "", patientRouteSheet: "", value: ""},
                                this.cleanData()
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    } else {
                        this.$store.dispatch('updatePatientAudio', this.audioEntity).then(response => {
                            this.dialog = false
                            this.audio = new PatientAudio()
                            this.audioEntity = {date: "", patientRouteSheet: "", value: ""},
                                this.cleanData()
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                }
            },

            deleteItem(item) {
                this.editedIndex = this.audios.indexOf(item)
                this.audioEntity = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientAudio', this.audioEntity.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        // Para chrome
                        date = new Date(dateReg);
                    } else {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
            createDiagnostic() {
                this.dialogDiagnostic = true
                this.audio.diagnosticos = [];
            },
            newDiagnostic() {
                this.audio.diagnosticos.push(this.diagnostico)
                this.diagnostico = {nombre: "", clase: "", tipo: ""}
            },
            deleteDiagnostic(item) {
                const index = this.audio.diagnosticos.indexOf(item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.audio.diagnosticos.splice(index, 1)

            },
            reloadData() {
                this.$store.dispatch('getPatientAudioByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                    this.audios = response.data;                    
                    let audioBasal;
                    let ultimoAudio;                    
                    for (let i = 0; i < this.audios.length; i++) {
                        this.audios[i].value = JSON.parse(this.audios[i].value);                        
                        if (i == 0) {
                            audioBasal = this.audios[i];                            
                        } else if (i == (this.audios.length - 1)) {
                            ultimoAudio = this.audios[i];                            
                        }                        
                    }
                    let valueBasal;
                    if (audioBasal) {
                        console.log(audioBasal)
                        valueBasal = audioBasal.value;
                        this.dataOidoDerecho.push({
                            x: [250,500,1000,2000,3000,4000,6000,8000],
                            y: [valueBasal.od1 * -1,valueBasal.od2  * -1,valueBasal.od3 * -1,
                                valueBasal.od4 * -1,valueBasal.od5 * -1,valueBasal.od6 * -1,
                                valueBasal.od7 * -1,valueBasal.od8 * -1],
                            type:"scatter",
                            name:this.getFormattedDate(audioBasal.date),
                            marker: {color:'red',size:8,symbol:'circle'}
                        });
                        this.dataOidoIzquierdo.push({
                            x: [250,500,1000,2000,3000,4000,6000,8000],
                            y: [valueBasal.oi1 * -1,valueBasal.oi2 * -1,valueBasal.oi3 * -1,
                                valueBasal.oi4 * -1,valueBasal.oi5 * -1,valueBasal.oi6 * -1,
                                valueBasal.oi7 * -1,valueBasal.oi8 * -1],
                            type:"scatter",
                            name:this.getFormattedDate(audioBasal.date),
                            marker: {color:'blue',size:8,symbol:'x'}
                        });
                    }
                    let valueUltimoAudio;
                    if (ultimoAudio) {
                        console.log(ultimoAudio)                                        
                        valueUltimoAudio = ultimoAudio.value;
                        this.dataOidoDerecho.push({
                            x: [250,500,1000,2000,3000,4000,6000,8000],
                            y: [valueUltimoAudio.od1 * -1,valueUltimoAudio.od2  * -1,valueUltimoAudio.od3 * -1,
                                valueUltimoAudio.od4 * -1,valueUltimoAudio.od5 * -1,valueUltimoAudio.od6 * -1,
                                valueUltimoAudio.od7 * -1,valueUltimoAudio.od8 * -1],
                            type:"scatter",
                            name:this.getFormattedDate(ultimoAudio.date),
                            marker: {color:'red',size:8,symbol:'circle'}
                        });
                        this.dataOidoIzquierdo.push({
                            x: [250,500,1000,2000,3000,4000,6000,8000],
                            y: [valueUltimoAudio.oi1 * -1,valueUltimoAudio.oi2 * -1,valueUltimoAudio.oi3 * -1,
                                valueUltimoAudio.oi4 * -1,valueUltimoAudio.oi5 * -1,valueUltimoAudio.oi6 * -1,
                                valueUltimoAudio.oi7 * -1,valueUltimoAudio.oi8 * -1],
                            type:"scatter",
                            name:this.getFormattedDate(ultimoAudio.date),
                            marker: {color:'blue',size:8,symbol:'x'}
                        });
                    }
                    if (valueBasal && valueUltimoAudio) {                        
                        let promedioOd = ((valueUltimoAudio.od4 - valueBasal.od4) 
                                        + (valueUltimoAudio.od5 - valueBasal.od5)
                                        + (valueUltimoAudio.od6 - valueBasal.od6)) / 3;                        
                        if (promedioOd > 10) {
                            this.stsReportableDerecho = true;
                        }
                        
                        let promedioOi = ((valueUltimoAudio.oi4 - valueBasal.oi4) 
                                        + (valueUltimoAudio.oi5 - valueBasal.oi5)
                                        + (valueUltimoAudio.oi6 - valueBasal.oi6)) / 3;                                                
                        if (promedioOi > 10) {
                            this.stsReportableIzquierdo = true;
                        }
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            onClickChild(value) {
                this.audio.diagnosticos = [];
                this.audio.diagnosticos.push(...value);
                this.$refs.dtDiagnosticos.items = this.audio.diagnosticos;
            },
            openGraphic(item) {
                this.dataDetalle = [];
                this.dialogGraphic = true;
                this.editedIndex = this.audios.indexOf(item);
                this.audioEntity = Object.assign({}, item);
                this.dataDetalle.push({
                    x: [250,500,1000,2000,3000,4000,6000,8000],
                    y: [this.audioEntity.value.od1 * -1,this.audioEntity.value.od2 * -1,this.audioEntity.value.od3 * -1,
                        this.audioEntity.value.od4 * -1,this.audioEntity.value.od5 * -1,this.audioEntity.value.od6 * -1,
                        this.audioEntity.value.od7 * -1,this.audioEntity.value.od8 * -1],
                    type:"scatter",
                    name:"Oido derecho",
                    marker: {color:'red',size:8,symbol:'circle'}
                });
                this.dataDetalle.push({
                    x: [250,500,1000,2000,3000,4000,6000,8000],
                    y: [this.audioEntity.value.oi1 * -1,this.audioEntity.value.oi2 * -1,this.audioEntity.value.oi3 * -1,
                        this.audioEntity.value.oi4 * -1,this.audioEntity.value.oi5 * -1,this.audioEntity.value.oi6 * -1,
                        this.audioEntity.value.oi7 * -1,this.audioEntity.value.oi8 * -1],
                    type:"scatter",
                    name:"Oido izquierdo",
                    marker: {color:'blue',size:8,symbol:'x'}
                });                                             
            }


        },
        computed: {},
        created() {
            this.reloadData()
        },
        components: {
            Diagnosticos,
            Plotly
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patient/audio/Audio.vue